import { useAccountStore } from '@/store/use-account-store';
import { useOrdersStore } from '@/store/use-orders-store';
import { ColumnDef } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

type Props = {
  orderId: string;
};

export default function OrderType({ orderId }: Props) {
  const { t } = useTranslation();
  const address = useAccountStore((state) => state.address);
  const type = useOrdersStore(
    (state) => state.getOrders(address).orders[orderId].orderType,
  );

  if (!type) {
    return '-';
  }

  return t(`orderType.${type}`);
}

export const orderTypeAccessorFn = (id: string) => {
  const { address } = useAccountStore.getState();
  return useOrdersStore.getState().getOrders(address).orders[id].orderType;
};
